import Request from '@/lib/request.js'
import appConfig from '@/app.config.js'
import UserService from '@/lib/user.js'

export default {

    data () {
        return {
            isGenerating: false,
            isReadytoDownload: false,
            reports: {
                users: [],
                result: [],
                questions: []
            },
            file: {
                url: '',
                filename: '',
                urlXlsx: '',
                filenameXlsx: ''
            }
        }
    },

    methods: {
        sendToDrive (type) {
            window.___gcfg = {
                lang: 'en-US'
            };
            let path = type == 'pdf' ? this.file.url.slice(1) : this.file.urlXlsx.slice(1)
            let url = appConfig.baseUrl + path

            url = url.replace(/http\:/, '')
                .replace(/https\:/, '')

            // eslint-disable-next-line
            gapi.savetodrive.render('savedrive', {
                src: url,
                filename: type == 'pdf' ? this.file.filename : this.file.filenameXlsx,
                sitename: 'TheBigQuiz.net'
            });
        },

        downloadReport () {

            const userService = new UserService
            const token = userService.getToken()

            const request = new Request({
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            })

            const generateUrl = this.type == 'quiz' ? appConfig.api.quizReport : appConfig.api.pollReport

            this.isGenerating = true

            if (this.file.url.length && this.file.urlXlsx.length) {
                this.isGenerating = false
                return
            }

            this.$store.commit('toggleMainLoader', true)

            request.post(generateUrl, this.reports)
                .then(res => {
                    const token = res.data.data.path
                    const tokenXlsx = res.data.data.xlsx_path

                    this.file.url = token
                    this.file.filename = token.replace(/[/]uploads[/]pdf[/]download[/]/g, '')
                    this.file.urlXlsx = tokenXlsx
                    this.file.filenameXlsx = tokenXlsx.replace(/[/]uploads[/]xlsx[/]download[/]/g, '')
                    this.$store.commit('toggleMainLoader', false)
                    this.isGenerating = false
                    this.isReadytoDownload = true
                })
                .catch(() => {
                    this.isGenerating = false
                    this.isReadytoDownload = true

                    this.$store.commit('toggleMainLoader', false)
                })
        }
    }
}
